import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useFilmContext } from '../../../context/film/hooks/use-film-context';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { FilmSummary } from '../summary/film-summary';
import { FilmDetailsBanner } from './subcomponents/banner';
import { FilmDetailsSkeleton } from './subcomponents/skeleton';
import { defaultFilmDetailsProps, filmDetailsPropsValidator } from './types/props';
const b = bemClassBuilder('v-film-details');
export const FilmDetails = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { config } = props;
    const { film } = useFilmContext();
    if (!film)
        return enableSkeletonLoadingIndicators ? _jsx(FilmDetailsSkeleton, { thumbnail: config.thumbnail }) : null;
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsx(FilmDetailsBanner, Object.assign({}, props, { film: film })), _jsx(FilmSummary, Object.assign({}, props))] })));
});
FilmDetails.displayName = 'FilmDetails';
/**
 * The **Film Details** component renders the details of a film.
 */
export const FilmDetailsComponent = withComponentWrapper(FilmDetails, defaultFilmDetailsProps, filmDetailsPropsValidator);
